import store from "@/store/index.store"

import BlankLayout from "@/layouts/BlankLayout"
import MainLayout from "@/layouts/MainLayout.vue"
import { ROUTER_NAMES } from "@/constants/router.constants"
import router from "."

const CoursesPage = () =>
  import(/* webpackChunkName: "courses" */ "@/pages/courses/CoursesPage")
const CoursePage = () =>
  import(/* webpackChunkName: "courses" */ "@/pages/courses/CoursePage")
const LessonPage = () =>
  import(/* webpackChunkName: "courses" */ "@/pages/courses/LessonPage")

export default [
  {
    path: "/courses/:game/:course",
    name: ROUTER_NAMES.COURSE_PAGE,
    component: CoursePage,
    meta: {
      layout: {
        component: MainLayout,
      },
    },
    beforeEnter: async (_to, from, next) => {
      try {
        await Promise.all([
          store.dispatch("User/loadUser"),
          store.dispatch("Games/loadGames"),
        ])

        const loadCourseData = async () => {
          const shortcode = _to.params.course
          await store.dispatch("Courses/getCourseByShortcode", shortcode)
          const course = store.getters["Courses/currentCourse"]
          await store.dispatch("Courses/getChaptersByCourseId", course.id)
        }
        await Promise.all([
          loadCourseData(),
          store.dispatch("Optimizely/loadCoursePageTest")
        ])

        const game = _to.params.game
        const isGameAvailable = store.getters["Games/getGameByKey"](game)
        if (isGameAvailable) {
          next()
        } else {
          next("/404")
        }
      } catch (error) {
        next("/404")
      }
    },
  },
  {
    path: "/courses/:game/:course/:chapter/:lesson",
    name: "LessonPage",
    component: LessonPage,
    meta: {
      layout: {
        component: BlankLayout,
      },
    },
    beforeEnter: async (_to, from, next) => {
      try {
        await store.dispatch("User/loadUser")
        const user = store.getters["User/getUser"]
        const routeParams = _to.params
        const game = routeParams.game
        const course = routeParams.course
        const path = `/courses/${game}/${course}`
        if (!user) {
          // next("/register")
          window.location.href = path
          // console.log(path)
          // router.replace(`/courses/${game}/${course}`)
        } else {
          await store.dispatch("User/loadUserCapabilities")
          if (!store.getters["Courses/currentCourse"]) {
            await store.dispatch(
              "Courses/getCourseByShortcode",
              _to.params.course
            )
          }
          const course = store.getters["Courses/currentCourse"]
          if (!course.user_has_access) {
            window.location.href = path
          } else {
            const chapter = _to.params.chapter
            const lesson = _to.params.lesson
            await store.dispatch("Courses/getLessonById", {
              course: course.id,
              chapter,
              lesson,
            })
            next()
          }
        }
      } catch (error) {
        next("/404")
      }
    },
  },
  {
    path: "/courses/:game?",
    alias: "/programs/:game?",
    name: ROUTER_NAMES.COURSES_PAGE,
    component: CoursesPage,
    meta: {
      layout: {
        component: MainLayout,
      },
    },
    beforeEnter: async (_to, from, next) => {
      try {
        const game = _to.params.game
        if (!game) {
          try {
            await store.dispatch("User/loadUser")
            await store.dispatch("User/loadUserActiveGames")
          } catch (error) {}
          const currentActiveGame =
            store.getters["User/currentActiveGame"] || "leagueoflegends"
          return next({
            name: ROUTER_NAMES.COURSES_PAGE,
            query: _to.query,
            params: {
              game: currentActiveGame,
            },
          })
        }
        await Promise.all([
          store.dispatch("Courses/fetchCourses", { game }),
          store.dispatch("Games/loadGames"),
        ])
        const isGameAvailable = store.getters["Games/getGameByKey"](game)
        if (isGameAvailable) {
          next()
        } else {
          next("/404")
        }
      } catch (error) {
        next()
      }
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/courses.routes.js